// extracted by mini-css-extract-plugin
export default {"projectsSection":"style_projectsSection__MaAM7","more":"style_more__OOyUN","title":"style_title__G37PT","pagination":"style_pagination__HZRRv","active":"style_active__UcEO5"};